import { SearchModel } from './common';

/**
 * Tipos para matérias-primas e insumos conforme schema [ProductApi].[RawMaterial]
 *
 * MaterialType:
 *   0 = Matéria-Prima  (material que compõe o produto final, ex: couro, metal, tecido)
 *   1 = Insumo         (material de suporte, ex: papelão, plástico bolha, fita adesiva)
 *   2 = Composto       (preparado internamente a partir de outros materiais, ex: cola de flocagem, blend de floco)
 *   3 = Semiacabado    (item intermediário produzido no atelier, ex: cabide flocado, presilha/ombreira flocada, tira vinco pronto, couro cortado)
 */

export enum MaterialType {
  MateriaPrima = 0,
  Insumo = 1,
  Composto = 2,
  Semiacabado = 3,
}

export const MATERIAL_TYPE_OPTIONS = [
  { value: 0, label: 'Matéria-Prima', description: 'Material que compõe o produto final (ex: couro, metal, tecido)' },
  { value: 1, label: 'Insumo', description: 'Material de suporte (ex: papelão, plástico bolha, fita adesiva)' },
  { value: 2, label: 'Composto', description: 'Preparado internamente a partir de outros materiais (ex: cola de flocagem, blend de floco) — composição na Lista de Materiais' },
  { value: 3, label: 'Semiacabado', description: 'Item intermediário produzido no atelier (ex: cabide flocado, presilha/ombreira flocada, tira vinco pronto, couro cortado)' },
] as const;

export const UNIT_OPTIONS = [
  { value: 'UN', label: 'UN - Unidade' },
  { value: 'KG', label: 'KG - Quilograma' },
  { value: 'G', label: 'G - Grama' },
  { value: 'M', label: 'M - Metro' },
  { value: 'M2', label: 'M² - Metro quadrado' },
  { value: 'M3', label: 'M³ - Metro cúbico' },
  { value: 'L', label: 'L - Litro' },
  { value: 'ML', label: 'ML - Mililitro' },
  { value: 'CM', label: 'CM - Centímetro' },
  { value: 'PC', label: 'PC - Peça' },
  { value: 'CX', label: 'CX - Caixa' },
  { value: 'RL', label: 'RL - Rolo' },
  { value: 'FD', label: 'FD - Fardo' },
  { value: 'PT', label: 'PT - Pacote' },
] as const;

export interface RawMaterial {
  id: number;
  code: string;
  description: string;
  unit?: string;
  material_type: number; // 0 = Matéria-Prima | 1 = Insumo
  cost?: number;
  total_weight?: number;
  stock_quantity?: number;
  stock_quantity_available?: number;
  min_stock_quantity?: number;
  max_stock_quantity?: number;
  ncm?: string;
  notes?: string;
  is_active: boolean;
  created_at: string;
  updated_at: string;
  created_by: string;
  last_updated_by: string;
}

export interface RawMaterialFormData {
  code: string;
  description: string;
  unit?: string;
  material_type: number;
  cost?: number;
  total_weight?: number;
  stock_quantity_available?: number;
  min_stock_quantity?: number;
  max_stock_quantity?: number;
  ncm?: string;
  notes?: string;
  is_active: boolean;
}

export interface RawMaterialSearchModel extends SearchModel {
  searchCode?: string;
  materialType?: number;
  is_active?: boolean;
  low_stock?: boolean;
  out_of_stock?: boolean;
  in_stock?: boolean;
}

// Aliases para compatibilidade com padrão existente
export type RawMaterialFilters = RawMaterialSearchModel;
export type CreateRawMaterialRequest = RawMaterialFormData;
